import React from 'react'
import Swal from 'sweetalert2'
import { ApiDelete, ApiGet, ApiPost } from '../../../utils/apiServices'
import { Add, Edit } from '@carbon/icons-react'
import axios from 'axios'
import Constants from '../../../utils/Constants'
import { useQuery } from '@tanstack/react-query'




const UsersList = () => {


      const { data: USersdata, isLoading: USersisLoading , refetch } = useQuery({
        queryKey: ["USersdata"],
        queryFn: () => ApiGet("admin/users"),
        staleTime: Infinity,
        cacheTime: 1000 * 60 * 60,
      });   


    const GetApi = (endpoint) => {
        return axios({
            method: "get",
            url: Constants.url + endpoint,
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
        }).then((res) => {
            return res.data;
        });
    }



    const { data: RolesData, isLoading: RolesisLoading , } = useQuery({
        queryKey: ["RolesData"],
        queryFn: () => GetApi("roles"),
        staleTime: Infinity,
        cacheTime: 1000 * 60 * 60,
    });

    const role = RolesData





    const CreateUser = () => {
        const roleOptions = role.map((item, index) =>
            `<option value="${item.id}">${item.name}</option>`
        ).join('');


        Swal.fire({
            title: 'Create User',

            html: `  <div className="uk-margin uk-text-left">
                <label className="uk-form-label uk-text-bold" for="userName">Full Name</label>
                <input id="userName" className="uk-input" type="text" placeholder="Enter full name" required>
            </div>
            <div className="uk-margin uk-text-left">
                <label className="uk-form-label uk-text-bold" for="userEmail">Email</label>
                <input id="userEmail" className="uk-input" type="email" placeholder="Enter email address" required>
            </div>
            <div className="uk-margin uk-text-left">
                <label className="uk-form-label uk-text-bold" for="userPassword">Password</label>
                <input id="userPassword" className="uk-input" type="password" placeholder="Enter password" required>
            </div>
            <div className="uk-margin uk-text-left">
                <label className="uk-form-label uk-text-bold" for="userPassword">Role</label>
                <select id="userRole" className="uk-select">
                    <option value="">Select Role</option>
                    ${roleOptions}
                </select>
            </div>
            `,

            confirmButtonColor: 'black',
            cancelButtonColor: '#d33',
            showCancelButton: true,
            confirmButtonText: 'Create',
            preConfirm: async () => {
                const name = document.getElementById('userName').value;
                const email = document.getElementById('userEmail').value;
                const password = document.getElementById('userPassword').value;

                if (!name || !email || !password) {
                    Swal.showValidationMessage('All fields are required');
                    return false;
                }

                try {
                    Swal.showLoading();
                    const res = await ApiPost("admin/users", { name, email, password, roleRef: document.getElementById('userRole').value });
                    console.log(res, 'res')
                    if (res.status === "success") {
                        refetch();
                        Swal.fire({
                            icon: 'success',
                            title: 'Success',
                            text: res.message,
                        })

                        return true;
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: res.message,
                        })
                        return false;
                    }
                } catch (err) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: err.response.data.message || "Request failed",
                    })
                    return false;
                }
            },
            showLoaderOnConfirm: true,
            allowOutsideClick: () => !Swal.isLoading()
        })
    }


    const HandleUserDelete = async (id) => {
        
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: 'black',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            preConfirm: async () => {
                try {
                    Swal.showLoading();
                    const res = await ApiDelete("admin/users/" + id);
                    console.log(res, 'res')
                    if (res.status === "success") {
                        Swal.fire({
                            icon: 'success',
                            title: 'Success',
                            text: res.message,
                        })
                        refetch();
                        return true;
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: res.message,
                        })
                        return false;
                    }
                } catch (err) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: err.message || "Request failed",
                    })
                    return false;
                }
            },
            showLoaderOnConfirm: true,
            allowOutsideClick: () => !Swal.isLoading()
          })
        
            
    }


    return (
        <div className='uk-card uk-card-default uk-card-body '>

            <div className="uk-padding">

                <div className='uk-flex uk-flex-between'>
                    <div>
                        <h2>User Management
                        </h2>
                        <p>Assign roles to users and manage their permissions

                        </p>
                    </div>
                    <div>
                        <button className="uk-button uk-button-secondary" onClick={CreateUser}> Create User <Add size={22} /></button>
                    </div>
                </div>

                <table className="uk-table uk-table-hover uk-table-" id ='userTable'>
                    <thead className="uk-table-header " >
                        <tr >
                            <th className="uk-table-shrnk">Username</th>
                            <th className="uk-text-center">Role</th>
                            {/* <th className="uk-text-center">Action</th> */}
                        </tr>
                    </thead>
                    <tbody>
                        {USersdata?.map((user, index) => (
                            <tr key={index}>
                                <td>
                                    <div className='uk-flex '>
                                        <img className='uk-border-circle uk-margin-small-right' src="https://www.gravatar.com/avatar/?d=mp" borderRadius={10} width={50} height={50} alt="" />
                                        <div className='uk-padding-small-top'>
                                            <p>{user.name}</p>
                                            <p>{user.email}</p>
                                        </div>
                                    </div>

                                </td>

                                <td className="uk-text-center" style={{ verticalAlign: 'middle' }}>
                                    <span className="uk-badge uk-padding-small " style={{ backgroundColor: '#222', color: 'white', textTransform: 'uppercase', borderRadius: '4px', fontSize: '13px', width: 'fit-content', display: 'inline-block' }}>
                                        {user?.roleRef?.name}
                                    </span>
                                </td>
                                <td className="uk-text-center">
                                    <div className="uk-flex uk-flex-start" style={{ justifyContent: 'flex-end' }}>

                                        <button className="delbutton" onClick={() => HandleUserDelete(user._id)}>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 69 14"
                                                className="svgIcon bin-top"
                                            >
                                                <g clip-path="url(#clip0_35_24)">
                                                    <path
                                                        fill="black"
                                                        d="M20.8232 2.62734L19.9948 4.21304C19.8224 4.54309 19.4808 4.75 19.1085 4.75H4.92857C2.20246 4.75 0 6.87266 0 9.5C0 12.1273 2.20246 14.25 4.92857 14.25H64.0714C66.7975 14.25 69 12.1273 69 9.5C69 6.87266 66.7975 4.75 64.0714 4.75H49.8915C49.5192 4.75 49.1776 4.54309 49.0052 4.21305L48.1768 2.62734C47.3451 1.00938 45.6355 0 43.7719 0H25.2281C23.3645 0 21.6549 1.00938 20.8232 2.62734ZM64.0023 20.0648C64.0397 19.4882 63.5822 19 63.0044 19H5.99556C5.4178 19 4.96025 19.4882 4.99766 20.0648L8.19375 69.3203C8.44018 73.0758 11.6746 76 15.5712 76H53.4288C57.3254 76 60.5598 73.0758 60.8062 69.3203L64.0023 20.0648Z"
                                                    ></path>
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_35_24">
                                                        <rect fill="white" height="14" width="69"></rect>
                                                    </clipPath>
                                                </defs>
                                            </svg>

                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 69 57"
                                                className="svgIcon bin-bottom"
                                            >
                                                <g clip-path="url(#clip0_35_22)">
                                                    <path
                                                        fill="black"
                                                        d="M20.8232 -16.3727L19.9948 -14.787C19.8224 -14.4569 19.4808 -14.25 19.1085 -14.25H4.92857C2.20246 -14.25 0 -12.1273 0 -9.5C0 -6.8727 2.20246 -4.75 4.92857 -4.75H64.0714C66.7975 -4.75 69 -6.8727 69 -9.5C69 -12.1273 66.7975 -14.25 64.0714 -14.25H49.8915C49.5192 -14.25 49.1776 -14.4569 49.0052 -14.787L48.1768 -16.3727C47.3451 -17.9906 45.6355 -19 43.7719 -19H25.2281C23.3645 -19 21.6549 -17.9906 20.8232 -16.3727ZM64.0023 1.0648C64.0397 0.4882 63.5822 0 63.0044 0H5.99556C5.4178 0 4.96025 0.4882 4.99766 1.0648L8.19375 50.3203C8.44018 54.0758 11.6746 57 15.5712 57H53.4288C57.3254 57 60.5598 54.0758 60.8062 50.3203L64.0023 1.0648Z"
                                                    ></path>
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_35_22">
                                                        <rect fill="white" height="57" width="69"></rect>
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </button>

                                    </div>

                                </td>

                            </tr>
                        ))}
                        
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default UsersList